import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { CertificatePaymentSuccess } from '@components';
import {
  buildPrivateCertificatePaymentSuccessPath,
  getAccountUsernameFromPathname,
  useIsCertificateMemberLoggedIn,
} from '@share/components';
import type { ICertificatePaymentSuccessState } from '@share/common-types';
import { scrollTop } from '@share/utils';

import styles from './styles.module.scss';

export function PublicCertificatePaymentSuccessPage(): React.ReactElement | null {
  const history = useHistory();
  const location = useLocation<ICertificatePaymentSuccessState | undefined>();
  const isMemberLoggedIn = useIsCertificateMemberLoggedIn();

  useEffect(() => {
    scrollTop();
  }, []);

  useEffect(() => {
    if (!isMemberLoggedIn || !location.state) {
      return;
    }

    const accountUsername = getAccountUsernameFromPathname(location.pathname);
    if (!accountUsername) {
      return;
    }

    history.replace(buildPrivateCertificatePaymentSuccessPath(accountUsername), location.state);
  }, [history, isMemberLoggedIn, location.pathname, location.state]);

  if (isMemberLoggedIn) {
    return null;
  }

  return (
    <div className={styles.root}>
      <CertificatePaymentSuccess variant="public" />
    </div>
  );
}
